"use strict";
(function (global) {
  var TEMPLATE = 'formBuilder/date.compile.html';

  /**
  * Редактор для компоненты slick-грида, для реквизита типа "Дата"
  * @class WebAccess.components.dataViews.gridPlugins._editors.DateEditor
  * @extends WebAccess.components.dataViews.gridPlugins._editors.StringEditor
  * @since 5.2.0.1300
  */
  global.DateEditor = global.StringEditor.extend({

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отрисовка реквизита, при активации редактора на ячейке грида
    * @method WebAccess.components.dataViews.gridPlugins._editors.DateEditor#render
    * @since 5.2.0.1300     
    */
    render: function () {
      var me = this;

      var data = {};
      data.showTime = (me._column.dateType === 'DateTime');
      data.id = me.id;

      if (typeof me._value === "object") {
        data.value = formatDate(me._value);
      } else {
        data.value = me._displayValue;
      };
      
      WA.templates.render(TEMPLATE, data).done(function (html) {
        me._jContainer.html('<div class="dateEditor editor">' + html + '</div>');
        me._jContainer.find('input.input').addClass('noBorder');
        me._jInput = $('#' + me.id);

        me.initPicker();

        // Для планшетов и сматфонов отключаем клавиатурную навигацию.
        if (!WA.ENV.isTouch()) {
          me.initKeyNavigation();
        }

        me.renderState.resolve();
      });

      return me.renderState.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Включить дополнение по Enter
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._editors.DateEditor#initPicker   
    */
    initPicker: function () {
      var me = this;

      var isAllTextSelected = function (jInput) {
        var range = jInput.range();
        if (range.end - range.start === range.length && range.length) {
          return true;
        } else {
          return false;
        }
      }

      var hasText = function (jInput) {
        return !!jInput.val();
      }

      // По Enter дописываем все остальные части даты. Если ввесли только день, то дописываем месяц и год. Если ввели день и месяц, то дописываем год.
      me._jInput.on('keydown.dateControl', function (e) {
        var inp = me._jInput;
        var c = $.ui.keyCode;

        var key = e.which || e.keyCode;

        function adjustDate() {
          var d = ParseDateTime(inp);
          inp.datepicker("setDate", d);
          inp.data('selDate', d);
          //Шамов А.: Убрал потому, что "ставлю курсор в поле Дата, по стрелке вправо перехожу к другому полю и по стрелке вниз добавляю вторую пустую строку" - 
          // способом можно добавить бесконечное количество пустых строк (#103514).
          //inp.trigger('change');
          me.close();
        }

        //ENTER
        if (key === 13) {
          if (!isAllTextSelected(inp) && hasText(inp)) {
            adjustDate();
          }
        }

        //LEFT or RIGHT
        if (key === c.LEFT || e.keyCode === c.RIGHT) {
          if (inp.caret() === inp.val().length && key === c.RIGHT) {
            return adjustDate();
          }
          if (inp.caret() === 0 && key === c.LEFT) {
            return adjustDate();
          }
        }

        //DOWN or UP
        if (key === c.DOWN || key === c.UP) {
          return adjustDate();
        }

        // CTRL+;
        if ((key === 59 || key === 186) && e.ctrlKey) {
          var now = new Date();
          inp.datepicker("setDate", now);
          inp.data('selDate', now);
          inp.trigger('change');
          me.close();
        }

      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Закрыть окно выбора-даты
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._editors.DateEditor#close   
    */
    close: function () {
      if (!this._jInput.length) return;
      try {
        this._jInput.datepicker('hide');
      } catch (e) {
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение значение из реквизита
    * @method WebAccess.components.dataViews.gridPlugins._editors.DateEditor#serializeValue
    * @since 5.2.0.1300     
    */
    serializeValue: function () {
      var me = this;
      var control = me._getWrapper();
      var value = control.getValue();
      return { value: value, displayValue: value };
    },

    /**
    * Очистка поля
    * @method WebAccess.components.dataViews.gridPlugins._editors.DateEditor#destroy
    * @since 5.2.0.1300   
    */
    destroy: function () {
      var me = this;
      me.close();
      me._super();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить объект-обертку над контролом реквизита, с необходимыми методами типа getValue;
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._editors.DateEditor#_getWrapper
    */
    _getWrapper: function () {
      var me = this;
      if (!!me._wrapper) return me._wrapper;
      var parentCurrent = me._gridComp._parent.settings.current;
      return me._wrapper = new WA.CMP.wrappers.form.requisites.Date(me._column.id, me.id, parentCurrent.form);
    }
  });

})(window.WA.components.dataViews.gridPlugins._editors)